<template>
	<div class="subscription" :class="{ 'subscription--disabled': disabled }">
		<transition name="subscription__tooltip">
			<div class="subscription__tooltip" v-show="tooltipShown">
				<div class="title">
					<div
						class="recharge-icon"
						v-html="require('../../icons/recharge.svg')"
					/>
					<h3>{{ title }}</h3>
				</div>
				<div v-html="body" />
				<span class="subscription__tooltip__arrow"></span>
			</div>
		</transition>
		<div class="subscription__checkbox">
			<input
				type="checkbox"
				id="subscription-checkbox"
				:checked="value"
				:disabled="disabled"
				@input="$emit('input', $event.target.checked)"
			/>
			<label for="subscription-checkbox"
				>{{ $translations.products.product.subscription_discount }}
				<transition name="checkmark">
					<span class="checkmark" v-if="value"
						><i class="fal fa-check"/></span></transition
			></label>
		</div>
		<div class="subscription__details">
			<span
				class="t-link"
				@mouseenter="tooltipShown = true"
				@mouseleave="tooltipShown = false"
				@click="tooltipShown = true"
				><span
					class="subscription-icon"
					v-html="require('../../icons/recharge.svg')"
				/>
				{{ $translations.products.product.subscription_details }}</span
			>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		body: {
			type: String,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			tooltipShown: false
		};
	}
};
</script>

<style lang="scss" scoped>
.subscription {
	position: relative;

	&--disabled {
		filter: grayscale(1);
		cursor: not-allowed;
	}

	@include media("<=tablet") {
		text-align: center;
	}

	&__checkbox {
		display: flex;
		align-items: center;

		label {
			flex: 1;
		}

		@include media("<=tablet") {
			justify-content: center;
		}
	}

	&__details {
		margin-top: 8px;
		margin-left: 33px;
	}

	input[type="checkbox"] {
		appearance: none;
		background-color: $white;
		box-shadow: inset 0 0 2px rgba(black, 0.2);
		border-radius: 2px;
		width: 20px;
		height: 20px;
		transition: background-color 0.15s ease-in;

		&:checked {
			background-color: $teal;
			+ label::before {
				background-color: $white;
			}
		}
	}

	label {
		padding-left: 10px;
		font-size: 21px;
		position: relative;

		@include media("<=tablet") {
			font-size: 16px;
		}
	}

	&__tooltip {
		position: absolute;
		top: 0;
		left: 0;
		transform: translate(-15%, -100%);
		width: 344px;
		max-width: 100%;
		padding: 32px;
		background-color: #ffffff;
		box-shadow: 0 10px 20px 0 rgba(51, 66, 66, 0.13);
		border-radius: 4px;
		z-index: 1;

		@include media("<=tablet") {
			left: 50%;
			transform: translate(-50%, -100%);
		}

		&-enter-active,
		&-leave-active {
			transition: opacity 0.2s ease-in-out;
		}

		&-enter,
		&-leave-to {
			opacity: 0;
		}

		h3 {
			margin: 0;
			font-weight: 400;
			line-height: 22px;
			font-size: 24px;
			margin-left: 12px;
		}

		&__arrow {
			width: 50px;
			height: 25px;
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translate(-50%, 0);
			overflow: hidden;

			&::after {
				content: "";
				position: absolute;
				width: 20px;
				height: 20px;
				background: white;
				transform: translate(-50%, -50%) rotate(45deg);
				top: 0;
				left: 50%;
				box-shadow: 0 10px 20px 0 rgba(51, 66, 66, 0.13);
			}
		}
	}
}

.checkmark {
	position: absolute;
	top: 50%;
	left: -22px;
	color: white;

	transform: translateY(-50%);

	@include media("<=tablet") {
		left: -19px;
	}
}

.title {
	display: flex;
	align-items: center;
}

.recharge-icon {
	width: 25px;
}

.t-link {
	display: inline-flex;
	@include media("<=tablet") {
		font-size: 12px;
	}
}
.subscription-icon {
	width: 16px;
	display: inline-block;
	margin-right: 8px;
}
</style>
